import { createFileRoute } from '@tanstack/react-router';

/**
 * Login Route Definition
 * Component is loaded from login.lazy.tsx for automatic code splitting
 */
export const Route = createFileRoute('/login')({
  // No beforeLoad - login is a public route
});
